import { Box, Container, Flex } from "theme-ui";
import React, { memo, ReactNode, useState } from "react";
import { keyframes } from "@emotion/react";
import { Logo } from "../../components/Logo";
import { Icon } from "../../components/Icons";
import { Link } from "gatsby";
import { useSecureLinks } from "../../hooks/useSecureLinks";

const growY = keyframes`
from {
  transform: scaleY(0);
}
to {
  transform: scaleY(1);
}
`;
export interface GooglePPCHeaderProps {
  cta?: JSX.Element | string;
}

interface LoginRowItemProps {
  /** proportional width */
  fr: number;
  children: ReactNode;
}

const LoginRowItem: React.FC<LoginRowItemProps> = (props) => {
  return (
    <div
      sx={{
        flexBasis: `${props.fr * 100}%`,
        flexGrow: 1,
        flexShrink: 0,
        borderRightWidth: 1,
        borderRightColor: "#333333",
        borderRightStyle: "solid",
        borderLeftWidth: 1,
        borderLeftColor: "#767676",
        borderLeftStyle: "solid",
        "&:last-of-type": {
          borderRight: "none",
        },
        "&:first-of-type": {
          borderLeft: "none",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2,
        px: 0,
      }}
    >
      {props.children}
    </div>
  );
};

/**
 * Provides useful navigation links.
 */
export const GooglePPCHeader: React.FC<GooglePPCHeaderProps> = (props) => {
  const { cta } = props;
  const secureLinks = useSecureLinks();
  return (
    <Box
      as="header"
      sx={{
        flexDirection: "column",
        fontFamily: "body",
        boxShadow: "rgb(135, 135, 135) 0px 1px 2px 0px",
        zIndex: 2000,
        display: "flex",
        height: "70px",
        position: "sticky",
        borderBottom: "5px solid #645B88",
        bg: "#fff",
        borderBottomWidth: "5px",
        borderImage:
          "linear-gradient(to right, #645B88, #2E368F, #42368E, #D91828, #FFDD00) 1 stretch",
        alignItems: "baseline",
        top: 0,
      }}
      id="Site-Nav-Header"
    >
      <Flex
        as="nav"
        sx={{
          boxSizing: "border-box",
          minWidth: 0,
          width: "100%",
          bg: "#fff",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        aria-label="Main Menu"
      >
        <Container
          sx={{
            px: "15px",
            pb: 0,
            display: "flex",
            alignItems: "center",
            pt: "15px",
            justifyContent: "space-between",
            maxWidth: [null, null, "100%", "1360px"],
          }}
        >
          <Box>
            <Logo
              sx={{
                width: [180, null, null, 220],
                height: 35,
                display: "block",
                "&:focus": {
                  outline: "1px solid #1A1818",
                  border: "1px solid #1A1818",
                },
              }}
            />
          </Box>
          <Flex>
            {cta || (
              <Flex
                aria-labelledby="main-menu-heading"
                aria-label="Main Menu"
                sx={{
                  alignItems: "center",
                  listStyle: "none",
                  minHeight: "100%",
                  paddingLeft: 0,
                  flexDirection: ["column", "unset"],
                  alignItems: ["flex-start", "center"],
                }}
              >
                <a
                  href={secureLinks.loanApplication}
                  sx={{
                    variant: "buttons.primary",
                    ml: "25px",
                    py: "5px",
                    width: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  Apply Now
                </a>
              </Flex>
            )}
          </Flex>
        </Container>
      </Flex>
    </Box>
  );
};
export default memo(GooglePPCHeader);
